export default "__VITE_ASSET__CyiWx6HC__"